import { render, staticRenderFns } from "./AccordionEditor.vue?vue&type=template&id=d4c3016a&"
import script from "./AccordionEditor.vue?vue&type=script&lang=js&"
export * from "./AccordionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports